import {
  createMenu,
  deleteMenu,
  getMenu,
  getMenus,
  updateMenu,
} from '@/api/menuApi';
import type {
  CreateMenuRequest,
  MenuItem,
  UpdateMenuRequest,
} from '@/types/menu';

export const menuService = {
  getMenus: async (
    productId: string,
    options?: { includeHierarchy?: boolean },
  ): Promise<MenuItem[]> => getMenus(productId, options),
  getMenu: async (productId: string, menuItemId: string): Promise<MenuItem> =>
    getMenu(productId, menuItemId),
  createMenu: async (
    productId: string,
    data: CreateMenuRequest,
  ): Promise<MenuItem> => createMenu(productId, data),
  updateMenu: async (
    productId: string,
    menuItemId: string,
    data: UpdateMenuRequest,
  ): Promise<MenuItem> => updateMenu(productId, menuItemId, data),
  deleteMenu: async (productId: string, menuItemId: string): Promise<void> =>
    deleteMenu(productId, menuItemId),
};
